module.exports = __webpack_public_path__ + "img/logo (4).a529a386.png";